module.exports = __webpack_public_path__ + "img/hr-H-B-5-load-standup-shadow.19eaa652.png";